// extracted by mini-css-extract-plugin
export default {"title":"Hint_title__5AS6W","text":"Hint_text__2IEjX"};